import { Grid2 as Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';

import DrilldownItem from '@components/DrilldownItem';
import Form from '@components/Questionnaire/Form';

import { useCuration } from '@hooks/useCuration';

import type { QuestionnaireModel } from 'generated/types';

import type { FormValues } from './Card';

interface QuestionnaireFormProps {
  questionnaire?: QuestionnaireModel;
}

export default function QuestionnaireForm({
  questionnaire,
}: QuestionnaireFormProps) {
  const { values } = useFormikContext<FormValues>();
  const {
    state: { isEditing },
  } = useCuration();

  return (
    <>
      {isEditing ? (
        <Form data={questionnaire} namePrefix="questionnaireResponses." />
      ) : (
        <>
          {questionnaire?.item?.map(({ linkId, text }) => {
            return (
              <Grid size={{ xs: 3 }} key={`questionnaire-${linkId}`}>
                <DrilldownItem
                  label={text ?? linkId}
                  name={linkId}
                  readOnly
                  value={
                    values.questionnaireResponses &&
                    linkId in values.questionnaireResponses
                      ? values.questionnaireResponses[
                          linkId as keyof FormValues
                        ]
                      : null
                  }
                />
              </Grid>
            );
          })}
        </>
      )}
    </>
  );
}
